'use client'

import useSWR from 'swr'

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => r.json())

export function useCurrentUser() {
  const { data, error, isLoading, mutate } = useSWR('/api/auth/context', fetcher)

  return {
    user: data,
    scope: data?.scope || null,
    ai_credits: data?.ai_credits,
    tracking_code: data?.tracking_code,
    isLoading,
    isError: error,
    loggedIn: data?.logged_in === true,
    userId: data?._id ? Number(data._id) : null,
    email: data?.email || null,
    avatar: data?.avatar || null,
    name: data?.firstname ? `${data.firstname} ${data.lastname}` : null,
    firstname: data?.firstname,
    language: data?.language || data?.lang || null,

    theme: typeof data?.theme === 'number' ? data.theme : null,
    isDark: data?.theme === 1,

    refreshUser: mutate,
  }
}
